import { render, staticRenderFns } from "./WorkflowManager.vue?vue&type=template&id=4ecb71b2&scoped=true"
import script from "./WorkflowManager.vue?vue&type=script&lang=js"
export * from "./WorkflowManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecb71b2",
  null
  
)

export default component.exports